import { ProductThumbnail } from '@services/MarppleShop/features/ProductList/type';
import { Dimensions } from '@services/MarppleShop/features/ProductList/application/transformers';
import { ScaleVO } from '@services/MarppleShop/shared/value-objects/scale.ts';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';

export const thumbnailViewTransformer = {
  /**
   * CSS 스타일 문자열 생성
   */
  createStyle: (thumbnail: ProductThumbnail, dimensions: Dimensions): string | undefined => {
    const scale = ScaleVO.create(thumbnail.scale);

    if (scale.equals(ScaleVO.one())) {
      return undefined;
    }

    const styles = [
      `max-width:${dimensions.max_size}%`,
      `max-height:${dimensions.max_size}%`,
      (thumbnail.imageUrl.includes('data:image') ? `width:${dimensions.width}px;` : '').replace(/s/g, ''),
    ];

    return styles.join(';');
  },

  createResizedUrl: (thumbnail: ProductThumbnail, dimensions: Dimensions): string => {
    const resizeData = {
      url: thumbnail.imageUrl,
      width: dimensions.width,
      padding_size: dimensions.padding_size,
      quality: 92,
      bg: 'f6f6f6',
      format: 'webp' as const,
      r: thumbnail.dimensions.resizeLevel,
    };

    return getResizedUrl(resizeData);
  },

  calculateDimensions: (scale: number, resizeWidth: number): Dimensions => {
    const scaleVO = ScaleVO.create(scale);

    if (scaleVO.equals(ScaleVO.one())) {
      return {
        width: resizeWidth,
        max_size: 100,
        padding_size: 0,
      };
    }

    let width = Math.round(resizeWidth * scaleVO.value);

    // 홀수/짝수 정렬 - 직접 계산
    const resizeWidthIsOdd = resizeWidth % 2 === 1;
    const widthIsOdd = width % 2 === 1;

    if (resizeWidthIsOdd !== widthIsOdd) {
      width += 1;
    }

    return {
      width,
      max_size: scaleVO.value * 100,
      padding_size: (resizeWidth - width) / 2,
    };
  },
};
